import { Injectable } from '@angular/core';
import { SharedServiceRegistry } from '../../../shared-service-registry';
import { CoreServiceRegistry } from '../../../../core/core-service-registry';
import { SearchableEntityDataEditorService } from '../searchable-entity-data-editor.service';
import { DetailedEntityDataService } from './detailed-entity-data.service';
import { SearchEvent } from '../../../search/models/search-event';
import { ITEM_CLICK_EVENT } from '../../../search/search-constants';
import { SearchService } from '../../../search/search.service';
import { forEach } from '@angular/router/src/utils/collection';
import { NavigationService } from 'sce-core';
import { menuIdRouteMappings } from 'sce-core/constants';



@Injectable()
export class DetailedEntityDataEditorService extends SearchableEntityDataEditorService {

  protected dataService: DetailedEntityDataService;
  protected navService: NavigationService;
  constructor(protected coreServiceRegistry: CoreServiceRegistry,
    protected sharedServiceRegistry: SharedServiceRegistry,) {
    super(coreServiceRegistry, sharedServiceRegistry);
    this.navService = this.coreServiceRegistry.navigationService
  }

  protected refreshAutoPopulatedLookupProperty(row: any, baseProperty: string,
    propertyMap: any, isStartEvent: boolean, hasError: boolean) {
    // if this is a start event
    let isLoading: boolean = false;
    if (isStartEvent && row.cells[baseProperty].cVal && row.cells[baseProperty].cVal !== '') {
      isLoading = true;
    }
    const dependantProps = Object.keys(propertyMap);
    dependantProps.forEach(property => {
      if (property !== baseProperty) {
        if (isStartEvent) {
          row.cells[property].cValPrev = row.cells[property].cVal;
          row.cells[property].cVal = '';
        }
        row.cells[property].isLoading = isLoading;
      }
    });
    if (!isLoading) {
      row.cells[baseProperty].isValueInvalid = hasError;
      const propToFocus = hasError ? baseProperty : this.getNextPropertyToFocus(baseProperty);
      let agGridApi;
      if (this.dataService.getDetailsSearchService()) {
        agGridApi = this.dataService.getDetailsSearchService().getPagedData().aggridApi;
      } else {
        agGridApi = null;
      }
      const rowId = 0;
      if (agGridApi && agGridApi.getFocusedCell()) {
        agGridApi.setFocusedCell(agGridApi.getFocusedCell().rowIndex, propToFocus);
      } else {
        row.focusedCellId = propToFocus;
      }
    }
  }

  /**
   * method used to emit event when property value using lookup
   */
  public valueChanged(property, prevVal, currentValue) {
    if (prevVal === currentValue) {
      return;
    }
    const valueChangedObject = new Object();
    valueChangedObject['property'] = property;
    valueChangedObject['prevVal'] = prevVal;
    valueChangedObject['newVal'] = currentValue;
    this.dataService.valueChangedPublishEvent(valueChangedObject);
  }
  
  // method to navigate to details page based on selected id
  public navigateToHyperlink(params: any) {
    const searchEvent: SearchEvent = new SearchEvent(ITEM_CLICK_EVENT);
    searchEvent.selectedItemId = params.value.cVal;
    searchEvent.selectedProperty = params.colDef.field;
    searchEvent.selectedRow = params.context.componentParent.searchService
      .getPagedData().pageRows[params.rowIndex];
    // Assign tableId
    if (this.dataService.primarySearchParams && this.dataService.primarySearchParams.tableId) {
      searchEvent.message = this.dataService.primarySearchParams.tableId;
    } else {
      searchEvent.message = params.context.componentParent.metaData.moduleId;
    }
    params.context.componentParent.searchService.publishEvent(searchEvent);
  }
  //UWP-34174 method to navigate to a details page in a new tab based on selected id
  public navigateToHyperlinkMbol(params: any) {
    const searchEvent: SearchEvent = new SearchEvent(ITEM_CLICK_EVENT);
    searchEvent.selectedItemId = params.data.mbolKey.cVal;
    searchEvent.selectedProperty = params.colDef.field;
    searchEvent.selectedRow = params.context.componentParent.searchService
      .getPagedData().pageRows[params.rowIndex];
    //Using RouteKey if primarySearchParams or tableId is missing
    if (!this.dataService.primarySearchParams || !this.dataService.primarySearchParams.tableId) {
      const routeKey = menuIdRouteMappings.so_reference
      this.navService.navigateWithRouteParams(routeKey, [searchEvent.selectedItemId], true);
    }
    else {
      searchEvent.message = this.dataService.primarySearchParams.tableId;
      params.context.componentParent.searchService.publishEvent(searchEvent);
    }
  }

  // method to navigate to a page based on selected id
  public navigateToHyperlinkUsDf09(params: any) {
    const searchEvent: SearchEvent = new SearchEvent(ITEM_CLICK_EVENT);
    searchEvent.selectedItemId = params.data.soUdf09.cVal;
    searchEvent.selectedProperty = params.colDef.field;
    searchEvent.selectedRow = params.context.componentParent.searchService
      .getPagedData().pageRows[params.rowIndex];
    // Assign tableId
    if (this.dataService.primarySearchParams && this.dataService.primarySearchParams.tableId) {
      searchEvent.message = this.dataService.primarySearchParams.tableId;
    } else {
      searchEvent.message = params.context.componentParent.metaData.moduleId;
    }
    params.context.componentParent.searchService.publishEvent(searchEvent);
  }

  // [LFWM-2923] - to filter all the dropdown values when changing the storer value in accordion
  public populateDropdownValuesBasedOnStorerInAccordion() {
    const metaDataMap = this.dataService.primaryMetaDataMap;
    for (const key in metaDataMap) {
      if (metaDataMap[key].type === 'DROPDOWN' || metaDataMap[key].type === 'EDITABLEDROPDOWN') {
        if (!metaDataMap[key].originalCoptions) {
          metaDataMap[key].originalCoptions = metaDataMap[key].values;
        }
        this.dataService.primaryDataMap[key].cOptions = metaDataMap[key].values = this.getValuesBasedOnStorer(metaDataMap[key].originalCoptions);
      }
    }
  }
  // [LFWM-2923] - to filter all the dropdown values when changing the storer value in table
  public populateDropdownValuesBasedOnStorerInTables() {
    this.populateDropdownValuesBasedOnStorerInTable([this.dataService.detailsSearchService]);
  }
  // [LFWM-2923] - to filter all the dropdown values when changing the storer value in table
  public populateDropdownValuesBasedOnStorerInTable(tableSearchServices: SearchService[]) {
    tableSearchServices.forEach(tableSearchService => {
      if (tableSearchService && tableSearchService.getMetadata()) {
        const detailMetadata = tableSearchService.getMetadata()['columnList'];
        for (let index = 0; index < detailMetadata.length; index++) {
          if (detailMetadata[index].type === 'DROPDOWN' || detailMetadata[index].type === 'EDITABLEDROPDOWN') {
            if (!detailMetadata[index].originalCoptions) {
              detailMetadata[index].originalCoptions = detailMetadata[index].values;
            }
            detailMetadata[index].values = this.getValuesBasedOnStorer(detailMetadata[index].originalCoptions);
          }
        }
      }
    });
  }

  // [LFWM-2923] - filtering the dropdown values based on storer
  public getValuesBasedOnStorer(originalCoptions: any) {
    // LFWM-2951-In transfer screen and channelTransfer screen dropdown values should be filtered based on fromStorerKey
    const storerKey = this.dataService.primaryDataMap['storerKey'] || this.dataService.primaryDataMap['fromStorerKey'];
    let filteredCoptions;
    if (storerKey && storerKey.cVal) {
      filteredCoptions = originalCoptions.filter(element => element.storerkey &&
        element.storerkey.toUpperCase() === storerKey.cVal.trim().toUpperCase());
      if (filteredCoptions.length > 0) {
        filteredCoptions.unshift({ key: '', value: '- Select -', storerkey: null, userDefineValues: null });
      }
    }
    if (!filteredCoptions || filteredCoptions.length === 0) {
      filteredCoptions = originalCoptions.filter(element => !element.storerkey);
    }
    if (filteredCoptions.length === 1 && filteredCoptions[0].key === '' &&
        filteredCoptions[0].value.toLowerCase() === '- select -') {
        filteredCoptions = [];
    }
    return filteredCoptions;
  }
  // [LFWM-2923] - to filter all the dropdown values when changing the storer value in accordion
  public populateDropdownValuesBasedOnDefaultStorer(defaultStorerArray: any) {
    const metaDataMap = this.dataService.primaryMetaDataMap;
    for (const key in metaDataMap) {
      if (metaDataMap[key].type === 'DROPDOWN' || metaDataMap[key].type === 'EDITABLEDROPDOWN') {
        if (!metaDataMap[key].originalCoptions) {
          metaDataMap[key].originalCoptions = metaDataMap[key].values;
        }
        // tslint:disable-next-line:max-line-length
        this.dataService.primaryDataMap[key].cOptions = metaDataMap[key].values = this.getValuesBasedOnDefaultStorer(metaDataMap[key].originalCoptions, defaultStorerArray);
      }
    }
  }
  // [LFWM-2923] - filtering the dropdown values based on storer
  public getValuesBasedOnDefaultStorer(originalCoptions: any, defaultStorerArray: any) {
    defaultStorerArray = defaultStorerArray.map(x => x.trim().toUpperCase());
    let filteredCoptions = originalCoptions.filter(element => element.storerkey &&
        defaultStorerArray.includes(element.storerkey.toUpperCase()));
    if (filteredCoptions.length > 0) {
      filteredCoptions.unshift({ key: '', value: '- Select -', storerkey: null, userDefineValues: null });
    } else {
      filteredCoptions = originalCoptions.filter(element => !element.storerkey);
    }
    if (filteredCoptions.length === 1 && filteredCoptions[0].key === '' &&
      filteredCoptions[0].value.toLowerCase() === '- select -') {
      filteredCoptions = [];
    }
    return filteredCoptions;
  }
}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/services/searchable-entity/detailed-entity/detailed-entity-data-editor.service.ts